import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'

export const getTableStyles = (isMobile: boolean) => css`
  ${isMobile
    ? css`
        padding: 0 16px;
      `
    : null}
  .ant-table-cell {
    color: ${colors.NEUTRAL_0} !important;
  }
  .ant-table-measure-row {
    display: none !important;
  }
  .ant-table-thead > tr > th {
    padding: 8px 16px !important;
    background-color: ${colors.SECONDARY_300} !important;
    color: ${colors.NEUTRAL_70} !important;
    text-transform: uppercase;
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 17.4px !important;
  }
  .ant-table-thead > tr > th.ant-table-column-sort {
    background-color: ${colors.SECONDARY_300} !important;
    color: ${colors.NEUTRAL_0} !important;
    font-weight: 700 !important;
  }
  .ant-table-tbody > tr > td.ant-table-column-sort {
    background-color: transparent !important;
  }
  .ant-table-tbody > tr:nth-child(even) {
    background-color: ${colors.SECONDARY_400};
  }
  .ant-table-tbody > tr:nth-child(odd) {
    background-color: ${colors.SECONDARY_500};
  }
  .ant-table-tbody > tr > th,
  .ant-table-tbody > tr > td {
    border-bottom: none !important;
  }
  .ant-table-tbody > tr > td {
    padding: 8px 16px !important;
    vertical-align: middle;
  }
  .ant-table-tbody
    > tr:nth-child(even)
    > td.ant-table-cell.ant-table-cell-fix-left {
    background-color: ${colors.SECONDARY_500} !important;
  }
  .ant-table-tbody
    > tr:nth-child(odd)
    > td.ant-table-cell.ant-table-cell-fix-left {
    background-color: ${colors.SECONDARY_400} !important;
  }
  .ant-table-tbody > tr:hover > td.ant-table-column-sort {
    background-color: #303846 !important;
  }
`
